module.exports = __webpack_public_path__ + "static/media/spadesColored.263c5cd6.svg";